/* istanbul ignore file */
import ChargingPointDetail from './ChargingPointDetail'
export default ChargingPointDetail
